import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BannerProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
  onDismiss?: () => void;
}

const Banner = React.forwardRef<HTMLDivElement, BannerProps>(
  ({ className, children, onDismiss, ...props }, ref) => {
    const [isVisible, setIsVisible] = React.useState(true);

    const handleDismiss = () => {
      setIsVisible(false);
      onDismiss?.();
    };

    if (!isVisible) {
      return null;
    }

    return (
      <div
        ref={ref}
        className={cn(
          'relative w-full bg-primary-500 rounded-none px-4 py-3 text-sm flex items-center',
          className
        )}
        {...props}
      >
        <div
          className="flex-1 text-white text-center font-medium [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: children as string }}
        />
        <button
          onClick={handleDismiss}
          className="absolute right-4 flex-shrink-0 text-white hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 rounded"
          aria-label="Dismiss banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }
);

Banner.displayName = 'Banner';

export { Banner };
